import { render, staticRenderFns } from "./PasswordConfirm.modal.vue?vue&type=template&id=b1964a16&scoped=true&"
import script from "./PasswordConfirm.modal.vue?vue&type=script&lang=js&"
export * from "./PasswordConfirm.modal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordConfirm.modal.vue?vue&type=style&index=0&id=b1964a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1964a16",
  null
  
)

export default component.exports